"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseUrl = void 0;
var parseUrl = function (cloudfrontBaseUrl, bucket, imageKey, imageProps) {
    var rawData = {
        bucket: bucket,
        key: imageKey,
        edits: {
            resize: {
                width: imageProps === null || imageProps === void 0 ? void 0 : imageProps.width,
                height: imageProps === null || imageProps === void 0 ? void 0 : imageProps.height,
                fit: imageProps === null || imageProps === void 0 ? void 0 : imageProps.resizeMode,
            },
            grayscale: imageProps === null || imageProps === void 0 ? void 0 : imageProps.grayscale,
            flip: imageProps === null || imageProps === void 0 ? void 0 : imageProps.flip,
            flop: imageProps === null || imageProps === void 0 ? void 0 : imageProps.flop,
            negate: imageProps === null || imageProps === void 0 ? void 0 : imageProps.negate,
            flatten: imageProps === null || imageProps === void 0 ? void 0 : imageProps.flatten,
            normalise: imageProps === null || imageProps === void 0 ? void 0 : imageProps.normalise,
        },
    };
    return "".concat(cloudfrontBaseUrl).concat(btoa(JSON.stringify(rawData)));
};
exports.parseUrl = parseUrl;
